import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import LocationsEmptyStateSvg from '@web/assets/svg/Misc/empty-locations-state.svg';

const SVG_DISPLACEMENT = 29;

const LocationsEmptyState = () => (
  <Column mTop={60} alignItems="center">
    <Column mTop={20} mLeft={SVG_DISPLACEMENT} mBottom={20}>
      <LocationsEmptyStateSvg />
    </Column>
    <Text14 themeColor={ThemeColorType.gray} semiBold>
      {gettext('Looks like you have no locations yet.')}
    </Text14>
    <Text14 themeColor={ThemeColorType.gray} semiBold>
      {gettext('Add locations to be able to use them for scheduling shifts.')}
    </Text14>
  </Column>
);

export default LocationsEmptyState;
